import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface BankInfo {
  bankName?: string;
  accountNo?: string;
}

export interface PersonalInfo {
  maritalStatus?: string;
  nationality?: string;
  address?: string;
  phoneNumber?: string;
  dateOfBirth?: string;
  passportNo?: string;
  emergencyContact?: string;
  religion?: string;
}

export interface Member {
  _id: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  password?: string;
  role?: string;
  position?: string;
  org?: string;
  department?: string;
  completedWelcome?: boolean;
  isDemo?: boolean;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  bankInfo?: BankInfo;
  personalInfo?: PersonalInfo;
}

export interface WorkingHours {
  startTime?: string;
  endTime?: string;
  totalHours?: number;
  breakStart?: string;
  breakEnd?: string;
  overtimeAllowed?: boolean;
  maxHoursPerDay?: number;
  graceMinutes?: number;
  _id?: string;
}

export interface Department {
  _id: string;
  name: string;
  description?: string;
  handbook?: string;
  status?: string;
  organization?: string;
  members: Member[];
  supervisor?: string;
  workingHours?: WorkingHours;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
}

export type DepartmentsResponse = {
  success: boolean;
  message: string;
  data: Department[];
};

const fetchDepartmentsUsers = async (): Promise<DepartmentsResponse> =>
  (await customAxios.get<DepartmentsResponse>("/departments/users")).data;

export const useGetDepartmentsWithUsers = () =>
  useQuery<DepartmentsResponse, AxiosError>(
    ["departments", "users"],
    fetchDepartmentsUsers,
    {
      onError: (error) =>
        showNotification({
          title: "Error Loading Departments",
          message:
            (error.response?.data as { message?: string })?.message ??
            "Failed to load departments",
          color: "red",
        }),
      staleTime: 0,
      retry: 1,
      refetchOnMount: "always",
    }
  );
